const theme = {
  colors: {
    primary: "#0B0B0B",
    text: "#F3F3F3",
    accent: "#D94141",
    gray: "#5A5A5A",
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Inter', sans-serif",
  },
  spacing: {
    sm: "8px",
    md: "16px",
    lg: "32px",
    xl: "64px",
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
  },
};



export { theme };